import { render } from "./App.vue?vue&type=template&id=2cced494"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=2cced494&lang=css"

import exportComponent from "D:\\projekt.dom\\vue\\app.veolab\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__